<div
    id="statistic-overview"
    class="statistic-overview--wrapper"
>
    <app-title-bar
        [title]="'mws.statistics' | i18n"
        [subtitle]="'mws.overview' | i18n"
        [showFilterDropdown]="false"
        [searchBar]="false"
    ></app-title-bar>

    <div class="shopping-article-overview--list">
        <div class="layout-grid">
            <div class="scrolling--col sidebar-column--buttons">
                <div class="sidebar--button-grid">
                    @if (coreService.checkAbility('execute', 'ui.statistic.recipe')) {
                        <div
                            class="grid-item"
                            (click)="onShowRecipeStatistics()"
                        >
                            <app-overview-selectcard
                                [icon]="'oc-recipestatistics'"
                                [cardTitle]="'mws.statistics.recipe' | i18n"
                                [styleClass]="showRecipeStatistics ? 'card-selected' : ''"
                            ></app-overview-selectcard>
                        </div>
                    }
                    @if (coreService.checkAbility('execute', 'ui.statistic.purchase')) {
                        <div
                            class="grid-item"
                            (click)="onShowPurchaseStatistics()"
                        >
                            <app-overview-selectcard
                                [icon]="'oc-purchasingstatistics'"
                                [cardTitle]="'mws.statistics.purchase' | i18n"
                                [styleClass]="showPurchaseStatistics ? 'card-selected' : ''"
                            ></app-overview-selectcard>
                        </div>
                    }
                </div>
            </div>
            <div class="scrolling--col">
                <!-- INFO: z.Zt. keine expliziten Privilegien, es gibt nur eine Auswertung -->
                @if (showRecipeStatistics) {
                    <div class="card-grid">
                        <div class="grid-item">
                            <app-overview-card
                                [styleClass]="'oc-recipestatistics'"
                                [imgBackgroundColor]="'#144263'"
                                [showRating]="false"
                                [title]="'mws.statistics.recipe.chart' | i18n"
                                (click)="openRecipeStatistics()"
                            ></app-overview-card>
                        </div>
                    </div>
                }
                <!-- INFO: z.Zt. keine expliziten Privilegien, es gibt nur eine Auswertung -->
                @if (showPurchaseStatistics) {
                    <div class="card-grid">
                        <div class="grid-item">
                            <app-overview-card
                                [styleClass]="'oc-purchasingstatistics'"
                                [imgBackgroundColor]="'#144263'"
                                [showRating]="false"
                                [title]="'mws.statistics.purchase.chart' | i18n"
                                (click)="openPurchaseStatistics()"
                            ></app-overview-card>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
</div>
